import { createJSONStorage, persist } from "zustand/middleware";

import type { CheckoutSlice } from "./checkout-slice";
import { createCheckoutSlice } from "./checkout-slice";
import { create } from "./custom-create";
import type { TreatmentSlice } from "./treatment-slice";
import { createTreatmentSlice } from "./treatment-slice";
import type { UrlParamsSlice } from "./url-params-slice";
import { createUrlParamsSlice } from "./url-params-slice";
import type { UserSlice } from "./user-slice";
import { createUserSlice } from "./user-slice";

export const useOnboardingStore = create<
  UserSlice & TreatmentSlice & CheckoutSlice & UrlParamsSlice
>()(
  persist(
    (...args) => ({
      ...createUserSlice(...args),
      ...createTreatmentSlice(...args),
      ...createCheckoutSlice(...args),
      ...createUrlParamsSlice(...args),
    }),
    {
      name: "onboarding-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
